import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type ConfirmChangeScreen =
    Extract<Screen, { type: "confirmChange" }>;

export class ConfirmChangeScreenMapper
    implements ScreenMapper<ConfirmChangeScreen> {

    public readonly type =
        "confirmChange" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: ConfirmChangeScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            selectedSticker:
                screen.new_subscription?.sticker_id
                ?? null,

            productTitle:
                screen.product_title
                ?? null,

            primaryScreen: {

                type: "confirmChange"

            },

            isLoading: false

        });

    }

}